import { Topic } from "shared/types";

export const useTopicMetaData = (topic: Topic) => {
  const thumbnailUrl = topic.thumbnail
    ? `https://cdn.dears.media/topic_element/${topic.thumbnail.filename}`
    : null;

  return {
    url: `https://miror.jp/${topic.mediaType}/column/${topic.id}`,
    thumbnailUrl,
    siteName: topic.mediaType === "press" ? "ミラープレス" : "ミラクル",
  };
};
